/**
 * @fileoverview Toast notification component.
 */

import { postToHost } from "../../../core/messenger";
import { validateToast, logValidationErrors } from "../../../core/validation";
import { UI_EVENTS } from "../events";
import type { ToastSubModule, ToastOptions } from "../types";

/**
 * Create the toast sub-module.
 */
export function createToastSubModule(): ToastSubModule {
  const showToast = (options: ToastOptions): void => {
    const validation = validateToast(options);
    if (!validation.valid) {
      logValidationErrors(UI_EVENTS.TOAST, validation.errors);
      return;
    }
    postToHost(UI_EVENTS.TOAST, {
      type: options.type,
      message: options.message,
      duration: options.duration,
    });
  };

  return {
    /**
     * Show a toast notification.
     */
    show: showToast,

    /**
     * Show success toast.
     */
    success(message: string, duration?: number): void {
      showToast({ type: "success", message, duration });
    },

    /**
     * Show error toast.
     */
    error(message: string, duration?: number): void {
      showToast({ type: "error", message, duration });
    },

    /**
     * Show warning toast.
     */
    warning(message: string, duration?: number): void {
      showToast({ type: "warning", message, duration });
    },

    /**
     * Show info toast.
     */
    info(message: string, duration?: number): void {
      showToast({ type: "info", message, duration });
    },
  };
}
